import { ComponentProps, CSSProperties, FC, PropsWithChildren, useContext } from "react";
import { EnrollmentContext } from "@/state";

type ThemedH3Props = ComponentProps<"h3">;
type ThemedH5Props = ComponentProps<"h5"> & { $border?: boolean };

export const ThemedH3: FC<PropsWithChildren<ThemedH3Props>> = (props) => {
  const { children, style, ...headingProps } = props;

  const themedStyle: CSSProperties = {
    fontSize: "20px",
    fontWeight: 600,
    color: "#313e48",
    lineHeight: "24px",
    letterSpacing: "0px",
    textAlign: "left",
    margin: 0,
    ...(style || {}),
  };

  return <h3 {...headingProps} style={themedStyle}>{children}</h3>;
};

export const ThemedH5: FC<PropsWithChildren<ThemedH5Props>> = (props) => {
  const { children, style, $border, ...headingProps } = props;
  const [state] = useContext(EnrollmentContext);
  const theme = state.experienceData?.theme;
  const font = (theme as { font?: string } | undefined)?.font || "Source Sans 3";
  const primaryColor = theme?.primary_color || "#00000000";

  const themedStyle: CSSProperties = {
    fontFamily: font,
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0px",
    textAlign: "center",
    width: "fit-content",
    margin: 0,
    height: "33px",
    borderBottom: `solid 4px ${$border ? primaryColor : "#00000000"}`,
    ...(style || {}),
  };

  return <h5 {...headingProps} style={themedStyle}>{children}</h5>;
};
